// COMPONENTS
import Card from "../app/Card";
// IMAGES
import agentSearch from "../../assets/agent-search.gif";
import Modal from "../app/Modal";
import { useState } from "react";
import { useNavigate } from "react-router-dom";

export interface AgentSearchProps {
  resetStep: () => void;
  nextDispatchOrderPage?: () => void;
}

export default function AgentSearch({
  resetStep,
  nextDispatchOrderPage,
}: AgentSearchProps) {
  const [cancelRideModal, setCancelRideModal] = useState(false);
  const navigate = useNavigate();
  return (
    <div>
      <Card header="Searching for available agents">
        <div className="space-y-7">
          <div>
            <img src={agentSearch} alt="" />
          </div>
          <div
            onClick={() => setCancelRideModal(!cancelRideModal)}
            className="bg-error/20 rounded-lg mt-10"
          >
            <button type="submit" className="w-full font-medium text-error">
              Cancel
            </button>
          </div>
        </div>
      </Card>

      {/* CANCEL MODAL */}
      <Modal
        header="Cancel ongoing request"
        openModal={cancelRideModal}
        setOpenModal={() => setCancelRideModal(!cancelRideModal)}
      >
        <div className="max-w-[400px] mx-auto py-20">
          <h1 className="text-xl lg:text-2xl font-semibold text-center">
            You attempted to cancel an ongoing request
          </h1>
        </div>
        <div>
          <button
            onClick={() => {
              navigate("/dashboard");
              resetStep();
            }}
            className="bg-primary text-white font-medium text-lg w-full my-2"
          >
            Confirm
          </button>
          <button
            onClick={nextDispatchOrderPage}
            // onClick={() => setCancelRideModal(!cancelRideModal)}
            className="bg-border/30 text-themeText font-medium text-lg w-full my-2"
          >
            Don't cancel
          </button>
        </div>
      </Modal>
    </div>
  );
}
